module.exports = __webpack_public_path__ + "assets/img/pav_logo3.d6905ece.jpg";